import { jsx } from 'react/jsx-runtime';

const SvgPersonOne = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5Zm0-8c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3ZM18.7 14H5.3l-2.91 8h14.96l-.73-2H5.24l1.46-4h10.6l2.18 6h2.13l-2.91-8Z" }) }));

export { SvgPersonOne as default };
//# sourceMappingURL=PersonOne.es.js.map
